import React from 'react'
import { Grid } from '@mui/material'
import './home.css'
import Search from '../Search/Search'
import DetailsBox from '../../DetailsBox/DetailsBox'
import Blocks from '../Table/Blocks'
import Transactions from '../Table/Transactions'
import Footer from '../../Footer/Footer'

export default function Home() {
  return (
    <>
      <div className="home_container" style={{ background: '#222431' }}>
        <Grid container sx={{ overflow: 'hidden', justifyContent: 'center' }}>
          <Grid md={12} item xs={12}>
            <Search />
          </Grid>
        </Grid>

        <Grid container sx={{ overflow: 'hidden' }}>
          <Grid md={12} item sm={12} xs={12}>
            <DetailsBox />
          </Grid>
        </Grid>
        <Grid container sx={{ overflow: 'hidden', p: 1, alignItems: 'start' }}>
          <Grid md={6} item sm={12} sx={{ p: 1, width: '100%' }}>
            <Blocks sx={{ width: '100%' }} />
          </Grid>
          <Grid md={6} item sm={12} sx={{ p: 1, width: '100%' }}>
            <Transactions sx={{ width: '100%' }} />
          </Grid>
        </Grid>
        <Footer />
      </div>
    </>
  )
}
